export const LoadingThreeDot = () => {
  return (
  <span className="flex space-x-2">
    <span className="w-3 h-3 bg-opera-red rounded-full animate-bounce"></span>
    <span className="w-3 h-3 bg-opera-red rounded-full animate-bounce [animation-delay:-.2s]"></span>
    <span className="w-3 h-3 bg-opera-red rounded-full animate-bounce [animation-delay:-.4s]"></span>
  </span>
  );
}